import logoFull from "../assets/brand/tr-structures-logo-full.png";
import logoIcon from "../assets/brand/tr-structures-icon.png";

// Client-supplied TR Structures logo (transparent PNG, cropped to content).
// The mark carries its own green/orange brand color already, so it renders
// the same on light or dark backgrounds — `variant` is kept for API
// compatibility with callers that pass it.
const Logo = ({ variant = "dark", className = "", iconOnly = false }) => {
  return (
    <img
      src={iconOnly ? logoIcon : logoFull}
      alt="TR Structures"
      className={`h-11 md:h-12 w-auto object-contain ${className}`}
      data-variant={variant}
    />
  );
};

export default Logo;
